import { JobMatchQueryFilter } from 'src/app/core/models/jobMatchQueryFilter';
import * as _ from 'lodash';

export class MatchedCandidatesContainer {
    candidates: any[] = [];
    selectedCandidates: any[] = [];
    busy = false;
    candidatesExistFlag = true;
    defaultPageSize: any;
    searchObject: any;
    currentPromise: any = null;
    disableInfiniteScroll = false;
    searchByTextFlag = false;
    totalCandidateCount: any = null;
    selectAllDoneFlag = false;
    topMatches = 0;
    isFilterOn = false;

    constructor(
        private userId: any,
        private companyId: any,
        private jobId: any,
        private associateCandidatesDefaultFilter: any,
        private jobDetails: any,
        private pageSize: any,
        private jobMatchService: any,
        private jobService: any,
        private candidateService: any,
        private alertsAndNotificationsService: any
    ) {
        this.defaultPageSize = this.pageSize;
        this.searchObject = new SearchObject(this.jobId, this.companyId, this.pageSize, this.associateCandidatesDefaultFilter, this.jobDetails.fourDotFiveIntelligenceScore);
    }

    getNext() {
        if (this.busy) { return; }
        this.busy = true;

        if (this.searchObject.page == '') {
            this.searchObject.page = 1;
        }
        const tempSearchObject = _.cloneDeep(this.searchObject);
        if (this.searchByTextFlag) {
            delete tempSearchObject.minimumScore;
            delete tempSearchObject.maximumScore;
        } else {
            delete tempSearchObject.searchText;
        }
        if (tempSearchObject.numberOfDays == 0) {
            delete tempSearchObject.numberOfDays;
        }

        this._setIsFilterOn(tempSearchObject);
        tempSearchObject.loggedInUserId = this.userId;
        this.currentPromise = this.jobService.findMatchingCandidatesForJob(tempSearchObject, (data: any) => {
            if (this.searchObject.page == 1) {
                this.candidates = [];
            }
            if (data !== undefined && data != 'user cancellation') {
                this.totalCandidateCount = data.count;
                if (data.candidateMinimumInfoDtos.length > 0) {
                    data.candidateMinimumInfoDtos.forEach((val: any) => {
                        const basicCandidateInfo = this._getBasicCandidateInfo(val);
                        const currentIndex = this.candidates.length;
                        if (((currentIndex + 1) % 3) == 1) {
                            basicCandidateInfo.jobMatchesPopoverPosition = 'bottom-left';
                        } else if (((currentIndex + 1) % 3) == 0) {
                            basicCandidateInfo.jobMatchesPopoverPosition = 'bottom-right';
                        }
                        this.getCandidateJobMatches(basicCandidateInfo.id, this.userId, this.companyId, (jobMatchesData: any) => {
                            basicCandidateInfo.candidateJobMatches = jobMatchesData;
                            basicCandidateInfo.context = 'associateCandidates';
                        });
                        const index = this.selectedCandidates.findIndex((c: any) => c.id === basicCandidateInfo.id);
                        if (index >= 0) {
                            basicCandidateInfo.selectedFlag = true;
                        } else {
                            basicCandidateInfo.selectedFlag = false;
                        }
                        this.candidates.push(basicCandidateInfo);
                    });
                    if (data.candidateMinimumInfoDtos.length < this.searchObject.size || tempSearchObject.size != this.defaultPageSize) {
                        this.disableInfiniteScroll = true;
                    } else {
                        this.searchObject.page++;
                    }
                } else {
                    this.disableInfiniteScroll = true;
                }
                if (this.candidates.length > 0) {
                    this.candidatesExistFlag = true;
                } else {
                    this.candidatesExistFlag = false;
                }
            }
            this.busy = false;
        }, (error: any) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            this.disableInfiniteScroll = true;
            this.candidatesExistFlag = false;
            this.currentPromise = null;
            this.busy = false;
        });
    }

    private _setIsFilterOn(tempSearchObject: any) {
        const filter = tempSearchObject;
        if ((!filter.minimumScore && !filter.maximumScore && (filter.searchText.length > 0))
            || (!filter.searchText && (filter.minimumScore && filter.minimumScore > this.jobDetails.fourDotFiveIntelligenceScore))
            || (!filter.searchText && (filter.maximumScore && filter.maximumScore < 100))
            || (filter.numberOfDays && (filter.numberOfDays > 0))
            || filter.workLocationIds.length > 0
            || filter.sponsorships.length > 0
            || filter.jobTypes.length > 0
            || filter.jobSubTypes.length > 0
            || filter.sponsorships.length > 0
            || filter.salary > 0
            || filter.rate > 0
            || (filter.column != "" && filter.sortDirection != "")) {
            this.isFilterOn = true;
        } else {
            this.isFilterOn = false;
        }
    }

    private _getBasicCandidateInfo(candidate: any): any {
        const basicCandidateInfo: any = {};
        basicCandidateInfo.name = candidate.contact.firstname + ' ' + candidate.contact.lastname;
        basicCandidateInfo.id = candidate.id;
        basicCandidateInfo.email = candidate.contact.email;
        basicCandidateInfo.mobilePhone = candidate.contact.mobilephone;
        basicCandidateInfo.workPhone = candidate.contact.workphone;
        basicCandidateInfo.matchScore = candidate.matchScore;
        basicCandidateInfo.candidateStatus = candidate.candidateStatus;
        if (candidate.lastModifiedDate !== null) {
            basicCandidateInfo.lastModifiedDate = new Date(candidate.lastModifiedDate);
        }
        basicCandidateInfo.candidateJobMatches = [];
        basicCandidateInfo.jobMatchesPopoverPosition = 'bottom';
        if (basicCandidateInfo.matchScore === null) {
            basicCandidateInfo.matchScore = 'N/A';
        } else {
            basicCandidateInfo.intelligenceScorePassFlag = false;
            if (basicCandidateInfo.matchScore >= this.jobDetails.fourDotFiveIntelligenceScore) {
                basicCandidateInfo.intelligenceScorePassFlag = true;
            }
            basicCandidateInfo.matchScore = Math.floor(parseFloat(basicCandidateInfo.matchScore));
        }
        basicCandidateInfo.allowManualMatch = candidate.allowManualMatch;
        basicCandidateInfo.showOverride = candidate.showOverride;
        basicCandidateInfo.allowOverride = candidate.allowOverride;
        basicCandidateInfo.overrideFor = candidate.overrideFor;
        basicCandidateInfo.reasonForNoManualMatch = candidate.reasonForNoManualMatch;
        basicCandidateInfo.releaseDate = candidate.releaseDate;
        basicCandidateInfo.suspendedMonths = candidate.suspendedMonths;
        basicCandidateInfo.releasedCandidateDetail = candidate.releasedCandidateDetail;
        basicCandidateInfo.jobLeftDetail = candidate.jobLeftDetail;
        basicCandidateInfo.workLocations = candidate.workLocations;
        basicCandidateInfo.workLocationsMatchStatus = this.jobMatchService.getJobAndCandidateWorkLocationsMatchStatus(this.jobDetails.workLocations, candidate.workLocations);
        basicCandidateInfo.candidateAdditionalDetailsCard = candidate.candidateAdditionalDetailsCard;
        basicCandidateInfo.resumeExist = candidate.resumeExist;
        basicCandidateInfo.matchingMandatoryCriteria = candidate.matchingMandatoryCriteria;

        return basicCandidateInfo;
    }

    getCandidateJobMatches(candidateId: any, userId: any, companyId: any, successCallback: (data: any) => void) {
        const candidateJobMatches: any[] = [];
        const jobMatchesObject = new JobMatchQueryFilter();
        jobMatchesObject.candidateId = candidateId;
        jobMatchesObject.userId = userId;
        jobMatchesObject.companyId = companyId;
        jobMatchesObject.top5Flag = false;
        jobMatchesObject.candidateType = "OWN_CANDIDATES";
        jobMatchesObject.searchText = '';
        jobMatchesObject.vendorIds = [];
        this.candidateService.getCandidateJobMatches(jobMatchesObject, 1, 250, (data: any) => {
            data.forEach((val: any) => {
                val.jobMatchDate = new Date(val.jobMatchDate);
                candidateJobMatches.push(val);
            });
            if (successCallback) {
                successCallback(candidateJobMatches);
            }
        }, (error: any) => {
            console.log('candidate job matches get error - ', error);
        });
    }
}


class SearchObject {
    requisitionId: any;
    companyId: any;
    size: any;
    searchText = "";
    page: any = "";
    minimumScore: any;
    maximumScore: any = 100;
    numberOfDays = 0;
    withoutJobMatchScore = false;
    includeCandidatesMatchingMandatoryCriteria = false;
    requestSource: any;
    workLocationIds: any;
    sponsorships: any;
    jobTypes: any;
    jobSubTypes: any;
    salary: any;
    salaryDuration: any;
    rate: any;
    rateDuration: any;
    salaryCurrency: any;
    rateCurrency: any;
    column: any;
    sortDirection: any;
    includeCandidatesWithNoAdditionalDetails: any;

    constructor(jobId: any, companyId: any, size: any, associateCandidatesDefaultFilter: any, minimumScore: any) {
        this.requisitionId = jobId;
        this.companyId = companyId;
        this.size = size;
        this.minimumScore = minimumScore;
        this.requestSource = associateCandidatesDefaultFilter.requestSource;
        this.workLocationIds = associateCandidatesDefaultFilter.workLocationIds;
        this.sponsorships = associateCandidatesDefaultFilter.sponsorships;
        this.jobTypes = associateCandidatesDefaultFilter.jobTypes;
        this.jobSubTypes = associateCandidatesDefaultFilter.jobSubTypes;
        this.salary = associateCandidatesDefaultFilter.salary;
        this.salaryDuration = associateCandidatesDefaultFilter.salaryDuration;
        this.rate = associateCandidatesDefaultFilter.rate;
        this.rateDuration = associateCandidatesDefaultFilter.rateDuration;
        this.salaryCurrency = associateCandidatesDefaultFilter.salaryCurrency;
        this.rateCurrency = associateCandidatesDefaultFilter.rateCurrency;
        this.column = associateCandidatesDefaultFilter.column;
        this.sortDirection = associateCandidatesDefaultFilter.sortDirection;
        this.includeCandidatesWithNoAdditionalDetails = associateCandidatesDefaultFilter.includeCandidatesWithNoAdditionalDetails;
    }
}
